import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {} from "../../../../Redux/Actions/actions";
import Grid from "@mui/material/Grid";
import { IoLanguage } from "react-icons/io5";
import Tooltip from "@mui/material/Tooltip";
import { CiCalendarDate } from "react-icons/ci";
import { IoMdTime } from "react-icons/io";
import { TiWarningOutline } from "react-icons/ti";
import { LuServerCog } from "react-icons/lu";
import nodata from "../../../../Assets/images/svg/Data-unavailable.svg";
import { FaRegEye } from "react-icons/fa";
// chat style
import "../../../../Assets/style/components/audiochat.scss";
// import "../../Chat-component/Chat-Style/chat.css";
import { Typography, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import SummeryComponent from "../Summery-component/SummeryComponent";

import { IoMail } from "react-icons/io5";
import { IoMdChatboxes } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa6";
import { RiRobot2Fill } from "react-icons/ri";
import { BsMicrosoftTeams } from "react-icons/bs";

import Button from "@mui/material/Button";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const Interactiontab = (props) => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [showSummery, setShowSummery] = useState(false);
  const [sessionVal, setsessionVal] = useState([]);
  const [summerydata, setsummerydata] = useState();
  const [loader, setloader] = useState(false);

  const getSessionsDetails = async (value) => {
    setloader(true);
    await axios
      .post(
        BaseUrl + "/message/getSessions/",
        {
          email: props.externalChatData ? props.externalChatData.email : "",
          phonenumber: props.externalChatData
            ? props.externalChatData.phonenumber
            : "",
          date: value,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setsessionVal(res.data.data);
          setTimeout(() => {
            setloader(false);
          }, 2000);
        } else {
          setsessionVal([]);
          setloader(false);
        }
      });
  };

  const handleShowDetails = async (session_id) => {
    const access_token = localStorage.getItem("access_token");
    let data = {
      sessionId: session_id,
    };
    await axios
      .post(BaseUrl + "/message/getSummery/", data, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((sessions) => {
        if (sessions.data.success) {
          setsummerydata(sessions.data.data);
          setShowSummery(true);
        } else {
          setsummerydata();
          setShowSummery(false);
        }
      })
      .catch((err) => {
        console.log("handleShowDetails", err);
      });
  };
  useEffect(() => {
    getSessionsDetails(defaultValue);
  }, [props.externalChatData]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-end py-2">
          <input
            type="Date"
            max={defaultValue}
            className="form-control form-control-sm"
            style={{
              cursor: "pointer",
              height: "10px",
              width: "120px",
            }}
            onChange={(e) => {
              getSessionsDetails(e.target.value);
            }}
            value={defaultValue}
          />
        </div>
        <div
          style={{
            height: "50vh",
            overflowY: "scroll",
            background: "white",
          }}
        >
          {sessionVal.length > 0 ? (
            sessionVal.map((item) => {
              return (
                <div className="card card-history position-relative mb-2">
                  <div className="card-icons">
                    {(() => {
                      switch (item.channel) {
                        case "webchat":
                          return <IoMdChatboxes />;
                        case "from_whatsapp":
                          return <IoLogoWhatsapp />;
                        case "from_facebook":
                          return <FaFacebookF />;
                        case "from_twitter":
                          return <FaXTwitter />;
                        case "from_teams":
                          return <BsMicrosoftTeams />;
                        case "videochat":
                          return <FaVideo />;
                        case "voice":
                          return <IoCall />;
                        case "from_purple":
                          return <RiRobot2Fill />;

                        default:
                          return <IoMail />;
                      }
                    })()}
                  </div>
                  <div className="card-body p-2">
                    <Grid container>
                      <Grid item xs={12} sx={{ paddingRight: "37px" }}>
                        <Tooltip title="Agent" placement="top">
                          <Typography
                            variant="h6"
                            className="fs-13"
                            display="block"
                            color={"#0b3363"}
                            fontWeight={"600"}
                          >
                            {item.agent?.username}
                          </Typography>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6} className="d-flex align-items-center">
                        <Tooltip title="Date" placement="top">
                          <Box
                            className="d-flex align-items-center"
                            color={"primary"}
                          >
                            <CiCalendarDate className="me-2 fs-16" />
                            <Typography
                              variant="caption"
                              display="block"
                              sx={{ fontSize: "12px" }}
                            >
                              {moment(item.chat_started_at).format(
                                "DD/MM/YYYY"
                              )}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6} className="d-flex align-items-center">
                        <Tooltip title="Time" placement="top">
                          <Box className="d-flex align-items-center">
                            <IoMdTime className="me-2 fs-16" />
                            <Typography
                              variant="caption"
                              display="block"
                              sx={{ fontSize: "13px" }}
                            >
                              {item.chat_started_at
                                ? moment(item.chat_started_at).format(
                                    "hh:mm:ss a"
                                  )
                                : "--"}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6} className="d-flex align-items-center">
                        <Tooltip title="Language" placement="top">
                          <Box className="d-flex align-items-center">
                            <IoLanguage className="me-2 fs-16" />
                            <Typography
                              variant="caption"
                              display="block"
                              sx={{ fontSize: "13px" }}
                            >
                              {item.language}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6} className="d-flex align-items-center">
                        <Tooltip title="Disposition" placement="top">
                          <Box className="d-flex align-items-center">
                            <TiWarningOutline className="me-2 fs-14" />
                            <Typography
                              variant="caption"
                              display="block"
                              sx={{ fontSize: "13px" }}
                            >
                              {item.reason ? item.reason : "NA"}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={12} className="d-flex align-items-center">
                        <Tooltip title="Skill" placement="top">
                          <Box className="d-flex align-items-center">
                            <LuServerCog className="me-2 fs-14" />
                            <Typography
                              variant="caption"
                              display="block"
                              sx={{ fontSize: "13px" }}
                            >
                              {item.skillset ? item.skillset : "NA"}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="card-footer p-0">
                    <Grid item xs={12} className="d-flex align-items-center">
                      <Button
                        variant="text"
                        size="small"
                        sx={{ textTransform: "Capitalize" }}
                        fullWidth
                        onClick={() => handleShowDetails(item.chat_session_id)}
                      >
                        <FaRegEye className="me-2" />
                        View all
                      </Button>
                    </Grid>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <span className="mx-auto">
                <img
                  src={nodata}
                  alt="nodata"
                  style={{ width: "13rem", userSelect: "none" }}
                />
              </span>
              <span className="mx-auto">
                <h6 className="text-muted mt-2 fs-13">
                  {" "}
                  No interaction history available.
                </h6>
              </span>
            </div>
          )}
        </div>
      </div>

      {showSummery && (
        <SummeryComponent
          OpenDialog={showSummery}
          summerydata={summerydata}
          handleClose={() => {
            setShowSummery(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {})(Interactiontab);
